import { ProductCarousel } from "~/components/merchandise-components/ProductList";
import { CommunityPage } from "~/types/CommunityTypes";

const MerchTab = ({
    community,
}: {
    community?: Omit<CommunityPage, "leaders" | "topHosts">;
}) => {
    return (
        <div className="flex items-center justify-center">
            <ProductCarousel
                className="max-w-[95vw]"
                communitySlug={community?.slug}
                displayAffiliateProducts={community?.displayAffiliateProducts}
            />
        </div>
    );
};

export default MerchTab;
